<template>
    <div class="list-content">
        <div class="question-item" v-for="item in discussions">
            <div class="question-content">
                <div class="question-faceimg">
                    <img src="../../assets/img/touxiang.png" alt=""  width="55">
                </div>
                <div>
                    <p style="text-align: center; width: 100%"><span>{{item.createUserName}}</span> <span class="ml10">{{item.createTime | formatterDate}}</span>
                    
                    </p>
                    <p class="corblue">{{item.discussTitle}}</p>
                    <p v-html="decodeDiscuss(item.discussContent)"></p>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>

    import https from '@/https.js'
    import {dateFormat} from '@/api/utils.js'
    
    export default {
        name: "",
        props: ['courseId', 'catalogId','resourceId', 'isNextStep'],
        data() {
            return {
                tag:null,
                total:100,
                dialogVisible: false,
                editForm:{
                    title:null,
                    content:null
                },
                searchForm:{
                    searchValue:null,
                    searchSort:null,
                    pageSize:10,
                    page:1
                },
                discussions: [],
                currentPage4: 4
            }
        },

        filters: {
          formatterDate(val) {
            return dateFormat(val);
          }
        },
        methods: {
            replayQuestion(){
                window.location.href = 'step6-replay.html?questionId=111';
            },
          decodeDiscuss(val) {
              let content = decodeURIComponent(val);
            return content;
          },
            search() {
              if(this.resourceId) {
                let params = {
                  "resourceId": this.resourceId,
                };
                https.fetchPost('/discuss/getReplyList',params ).then((data) => {
                  let code = data.data.code;
                  let msg = data.data.msg;
                  if(code == 200) {
                    this.discussions.push(data.data.data);
                  } else {
                    this.$message({
                      type: 'info',
                      message: '审核失败:'+msg
                    });
                  }
                })
              } else {
                let params = {
                  "courseId": this.courseId,
                  "modelType": 2,
                  "pageIndex": 1,
                  "pageSize": 999,
                  "type": 0
                };
                https.fetchPost('/discuss/getDiscussList',params ).then((data) => {
                  let code = data.data.code;
                  let msg = data.data.msg;
                  if(code == 200) {
                    this.discussions = data.data.data;
                  } else {
                    this.$message({
                      type: 'info',
                      message: '审核失败:'+msg
                    });
                  }
                })
              }
              
            },

        },
        created(){
          this.search();
        },

    }
</script>

<style scoped>
    .list-content {
        font-size: 14px;
    }
</style>